import type { SupplierPalletShipmentRemoveOrderResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";

export const useRemoveOrderFromSellarDistributionPallet = (orderId: number) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `distribution-pallet-shipment/remove-order/${orderId}`,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as SupplierPalletShipmentRemoveOrderResponseType,
      ),
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SellarDistributionPalletShipment,
          response.supplierPalletShipmentId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SellarDistributionPalletShipment,
        ],
      });

      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SellarDistributionPalletShipment,
        ],
      });

      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders, orderId],
      });
    },
  });
};
